import { IQuestionRecord } from '@/contracts/modules/education/entities/IQuestionRecord'

/** Ответ GET /api/education/v1/questions */
export class QuestionsResponse {
  questions: IQuestionRecord[]

  constructor({ questions }: { questions: IQuestionRecord[] }) {
    this.questions = questions
  }
}
